module.exports = __webpack_public_path__ + "static/avatar_be-923c7a2f62a2ee4ef3461cd445b77ff2.png";